import Vue from 'vue'
import Vuex from 'vuex'
import Vapi from "vuex-rest-api"

Vue.use(Vuex);

function onError(state, error, axios) {
    if (error.response.status == 401) {
        window.location.href = '/accounts/login/?next=/'
    }
}


export const graph_data = new Vapi({
    baseURL: "",
    state: {
        graph_data: {}
    }
})
    .get({
        action: "getGraphData",
        property: "graph_data",
        path: "/graph_data/",
        onError: onError,

    })
    .getStore({createStateFn: false});

export const user_data = new Vapi({
    baseURL: "",
    state: {
        user_data: {}
    }
})
    .get({
        action: "getUserData",
        property: "user_data",
        path: "/user_data/",
        onError: onError,
    })
    .getStore({createStateFn: false});

const graph_button = {
    state: {
        selected: 'shares'
    },
    mutations: {
        press(state, button) {
            state.selected = button;
        }
    },
    actions: {
        press(context, button) {
            context.commit('press', button)
        }
    }

};

export default new Vuex.Store({
    modules: {
        graph_data: graph_data,
        graph_button: graph_button,
        user_data: user_data,
    }
})

